import { useState, useEffect } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';

// Looks up the ShippingArea for the currently saved shippingInfo (if any)
// and computes the shipping charge against the given subtotal — free once
// the subtotal reaches that area's minimum order value. Returns a null
// area (and 0 charge) until an address with an area has actually been
// chosen, e.g. on the Cart page before Shipping is filled in.
const useShippingCharge = (subtotal) => {
    const { shippingInfo } = useSelector((state) => state.cart);
    const [area, setArea] = useState(null);

    useEffect(() => {
        const fetchArea = async () => {
            if (!shippingInfo?.areaId) {
                setArea(null);
                return;
            }
            try {
                const { data } = await axios.get('/api/v1/shipping-areas');
                const found = data.areas.find((a) => a._id === shippingInfo.areaId);
                setArea(found || null);
            } catch (error) {
                console.error('Failed to load shipping area', error);
            }
        };
        fetchArea();
    }, [shippingInfo?.areaId]);

    if (!area) return { charge: 0, area: null };

    const charge = subtotal >= area.minOrderValue ? 0 : area.shippingCharge;
    return { charge, area };
};

export default useShippingCharge;
